import { Dayjs } from "dayjs";

export enum AnnouncementUserActionTypes {
    GET_NOVELTIES = "GET_NOVELTIES",
    GET_HEADER_PROJECTS = "GET_HEADER_PROJECTS",
    GET_SIMILAR = "GET_SIMILAR",
    ADD_NOVELTIES = "ADD_NOVELTIES",
    GET_ANNOUNCEMENT_BY_URLSLUG = "GET_ANNOUNCEMENT_BY_URLSLUG",
}

export interface IAnnouncementItem {
    urlSlug: string,
    title: string,
    description: string,
    imagePreview: string,
    date: Dayjs,
    announcementTime: string,
    hashtags: Array<string>
}

export interface IAnnouncementResponse {
    count: number,
    values: Array<IAnnouncementItem>
}

export interface IAnnouncementContentPage {
    content: string,
    additionalContent: string,
    priority: number,
    contentTypeId: number,
}

export interface IAnnouncementPage {
    title: string,
    description: string,
    keyWords: string,
    isFormNeeded: boolean,
    contents: Array<IAnnouncementContentPage>
}


export interface AnnouncementUserState {
    announcements: Array<IAnnouncementItem>,
    announcementsCount: number,
    projects: Array<IAnnouncementItem>,
    projectsCount: number,
    announcementPage: IAnnouncementPage
}


export interface GetNoveltiesAction {
    type: AnnouncementUserActionTypes.GET_NOVELTIES,
    payload: IAnnouncementResponse
}
export interface GetSimilarAction {
    type: AnnouncementUserActionTypes.GET_SIMILAR,
    payload: Array<IAnnouncementItem>
}
export interface AddNoveltiesAction {
    type: AnnouncementUserActionTypes.ADD_NOVELTIES,
    payload: IAnnouncementResponse
}
export interface GetAnnouncementByUrlSlugAction {
    type: AnnouncementUserActionTypes.GET_ANNOUNCEMENT_BY_URLSLUG,
    payload: IAnnouncementPage
}
export interface GetHeaderProjectsAction {
    type: AnnouncementUserActionTypes.GET_HEADER_PROJECTS,
    payload: IAnnouncementResponse
}

export type AnnouncementUserAction = GetNoveltiesAction | GetSimilarAction | AddNoveltiesAction | GetAnnouncementByUrlSlugAction | GetHeaderProjectsAction;